import { makeApi } from "@zodios/core";
import { z } from "zod";

import { discomfortTypeDtoSchema } from "@/types/backoffice/dto/dtd/discomfort-dto.ts";
import { dtdTypeDtoSchema } from "@/types/backoffice/dto/dtd/dtd-response-dto.ts";
import {
  odityExtendedModulatorControlMonitoringDtoSchema,
  odityExtendedModulatorExactDtoSchema,
} from "@/types/backoffice/dto/odity-extended/odity-extended-modulator-exact-dto.ts";

export const backofficeOdityExtendedApi = makeApi([
  {
    method: "get",
    path: "/exact/modulator/:csId",
    response: odityExtendedModulatorExactDtoSchema,
    alias: "findModulatorExactByCsId",
    parameters: [
      {
        name: "startDate",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "endDate",
        type: "Query",
        schema: z.string(),
      },
    ],
  },
  {
    method: "get",
    path: "/livevx/modulator/:modSerialNumber",
    response: odityExtendedModulatorControlMonitoringDtoSchema,
    alias: "findLiveVxDetailsByModulatorSerial",
  },
  {
    method: "get",
    path: "/dtd/analysis/site/:siteId/modulator/:csId",
    alias: "findDtdAnalysis",
    response: dtdTypeDtoSchema,
    parameters: [
      {
        name: "discomfortDateTime",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "uncomfortableConditionType",
        type: "Query",
        schema: discomfortTypeDtoSchema,
      },
      {
        name: "siteId",
        type: "Path",
        schema: z.number(),
      },
      {
        name: "csId",
        type: "Path",
        schema: z.number(),
      },
    ],
  },
]);
